import React from 'react'
import SignIn from '../fetures/sign-in/SignIn'

const SignInPage = () => {
  return (
    <SignIn/>
  )
}

export default SignInPage